import React , {Component} from "react";
import { Form, Input, Button } from 'antd'

import styled from 'styled-components'
const FormItem = Form.Item
const { TextArea } = Input

const Center = styled.div `
padding-left: 100px;
padding-right: 100px;
padding-bottom: 50px;
margin-top: 20px;
margin-left: 25px;
margin-right: 25px;
`

class HelpForm extends Component {

  constructor() {
    super();
    this.state = {
      formLayout: 'vertical',
    };
  }

  render () {
    const { getFieldDecorator } = this.props.form;
    const { formLayout } = this.state;
    const formItemLayout = formLayout === null;
    return (
      <Center>
        <h1 style={{textAlign: 'center'}}>Contactez-nous</h1>
        <Form layout={formLayout}>
         <FormItem
         {...formItemLayout}
         >
           {getFieldDecorator('Nom', {
             rules: [{ required: true, message: 'Veuilez saisir votre nom' }],
           })(
             <Input placeholder="Nom"/>
           )}
         </FormItem>
         <FormItem
            {...formItemLayout}
         >
           {getFieldDecorator('prénom', {
             rules: [{ required: true, message: 'Veuilez saisir votre prénom' }],
           })(
             <Input placeholder="Prénom"/>
           )}
         </FormItem>
         <FormItem
            {...formItemLayout}
         >
           {getFieldDecorator('téléphone', {
             rules: [{ required: false }],
           })(
             <Input placeholder="Téléphone" />
           )}
         </FormItem>
         <FormItem
            {...formItemLayout}
         >
           {getFieldDecorator('mail', {
             rules: [{ required: true, message: 'Veuilez saisir votre adresse mail' }],
           })(
             <Input placeholder="Adresse mail" />
           )}
         </FormItem>
         <FormItem
            {...formItemLayout}
         >
           {getFieldDecorator('message', {
             rules: [{ required: true, message: 'Veuilez saisir votre message' }],
           })(
             <TextArea rows={8} cols={52} placeholder="Votre message..." />
           )}
         </FormItem>
       </Form>
       <Button 
        type="primary"
        size="large"
        icon="mail"
       >Envoyer</Button>
      </Center>
    );
  }
}

export default Form.create() (HelpForm)
